import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sortedTutorials),function(tutorial){return _c('div',{key:tutorial.category,staticClass:"my-4"},[_c('h3',{staticClass:"mb-2"},[_vm._v(_vm._s(tutorial.category))]),_c(VRow,_vm._l((tutorial.videos),function(video){return _c(VCol,{key:video.id,attrs:{"cols":"12","sm":"4","md":"3"}},[_c('VideoTutorialCard',{attrs:{"videoTutorial":video}})],1)}),1)],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }